import { type CourseCardProps } from '#app/components/course-card.tsx'

type FlagshipProduct = {
	id: string
	promoKeywords: Array<string>
	homeCard: CourseCardProps
	coursesCard: CourseCardProps
	blogCard: CourseCardProps
}

const doctorsCard = {
	title: 'Doctor Finder & Instant Booking',
	description:
		'Help patients find specialists near them and book into real hospital systems - so your marketplace captures demand instead of losing it to call centers.',
	label: 'Growth system',
	courseUrl: '/work/doctor-finder-instant-booking',
	ctaLabel: 'See the business story',
	imageSrc: '/images/projects/doctors/cover-blue.webp',
	imageAlt: 'Doctor discovery product graphic',
	imageClassName: 'object-contain',
} satisfies CourseCardProps

const videoCard = {
	title: 'Secure Video Hosting at Scale',
	description:
		'Private streaming that feels first-party - with YouTube-backed storage and a lean middle tier designed for high concurrency and low cost.',
	label: 'Scale & cost',
	courseUrl: '/work/secure-youtube-video-hosting',
	ctaLabel: 'See the business story',
	imageSrc: '/images/projects/secure-video/cover-red.webp',
	imageAlt: 'Secure video streaming graphic',
	imageClassName: 'object-contain',
} satisfies CourseCardProps

const flagshipProducts = [
	{
		id: 'doctors',
		promoKeywords: [
			'marketplace',
			'growth',
			'product',
			'automation',
			'frontend',
			'engineering',
			'accessibility',
			'html',
			'css',
		],
		homeCard: { ...doctorsCard, horizontal: true },
		coursesCard: { ...doctorsCard, horizontal: true },
		blogCard: doctorsCard,
	},
	{
		id: 'secure-video',
		promoKeywords: [
			'systems',
			'performance',
			'engineering',
			'golang',
			'streaming',
			'architecture',
		],
		homeCard: videoCard,
		coursesCard: { ...videoCard, horizontal: true },
		blogCard: videoCard,
	},
] satisfies Array<FlagshipProduct>

function getMatchingFlagshipProducts(keywords: Array<string>) {
	const normalizedKeywords = new Set(
		keywords.map((keyword) => keyword.toLowerCase()),
	)

	const matches = flagshipProducts.filter((product) =>
		product.promoKeywords.some((keyword) =>
			normalizedKeywords.has(keyword.toLowerCase()),
		),
	)

	return matches.length ? matches.slice(0, 2) : flagshipProducts.slice(0, 1)
}

export { flagshipProducts, getMatchingFlagshipProducts }
export type { FlagshipProduct }
